import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const createConfigRequest = (entityId: string, configValues: any[], configurations?: any[]) => {
  return {
    entityId: entityId,
    configValues: configValues,
    ...(configurations && { configurations: configurations }),
  }
}

const createConfigOfEntity = (entityId: string, configValues: any[], configurations: any[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.createConfig,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: createConfigRequest(entityId, configValues, configurations),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { createConfigOfEntity }
